import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import { property } from 'lit/decorators.js';
import styles from './close-button.scss.js';
/**
 * @element cipublic-close-button
 */
export class CloseButton extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this);
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<button type="button"><cipublic-icon set="system" name="x" aria-label="${this.i18n.t('close')}" class="close-icon" role="img"></cipublic-icon>${this.showLabel ? this.i18n.t('close') : nothing}</button>`;
    }
}
__decorate([
    property({ type: Boolean })
], CloseButton.prototype, "showLabel", void 0);
//# sourceMappingURL=close-button.js.map